import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useWaiver} from 'Event/Step2/Waivers/Waiver'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function SignaturePromptConfig() {
  const save = useSaveTemplate()
  const {
    form: {control},
  } = useConfig()

  const {waiver, id} = useWaiver()

  const v = useAttendeeVariables()
  const addTranslation = useAddTranslation()

  const handleSave = (data: any) => {
    const signaturePrompt = replaceAtPath(
      data,
      `waiver.targets.${id}.signaturePrompt`,
      '{{waiver_signature_prompt}}',
    )

    save({
      ...data,
      localization: addTranslation({
        waiver_signature_prompt: signaturePrompt ?? '',
      }),
    })
  }

  return (
    <Config title="Signature Prompt" onSave={handleSave}>
      <SettingsPanel>
        <HTMLEditorContainer>
          <Controller
            name={`waiver.targets.${id}.signaturePrompt`}
            defaultValue={v(waiver.signaturePrompt)}
            control={control}
            render={({value, onChange}) => (
              <HTMLEditor data={value} onChange={onChange} />
            )}
          />
        </HTMLEditorContainer>
      </SettingsPanel>
    </Config>
  )
}
